var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',{attrs:{"enable-footer":false}},[_c('VContainer',{attrs:{"fluid":"","fill-height":""}},[_c('VRow',{staticClass:"overflow-x-hidden overflow-y-auto",attrs:{"justify-center":""}},[_c('VCol',{attrs:{"lg":"9","md":"12","sm":"12"}},[_c('EnterpriseConfirmation')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }